import http from './api'

const route = '/login/'

export default {
    show: (chaveativacao) => (
        http.post(route + 'perfil_produtor', { chaveativacao: chaveativacao })
    ),

    logar: (login, tokencontrato) => {
        return http.post('/login', {
            username: login.username,
            password: login.password,
            token_contrato: tokencontrato,
        }).then(response => {
            localStorage.setItem('magis_access_token', response.data.access_token)

            if (response.status === 201) {
                return http.post(route, {
                    login: login,
                    tokencontrato: tokencontrato,
                })
            }

            return {
                data: {
                    result: null,
                },
            }
        })
    },

    logout: (username, tokencontrato) => {
        return http.post(route + 'logout', {
            username: username,
            tokencontrato: tokencontrato,
        })
    },

    verificaEmpresa: (tokencontrato) => {
        return http.post(route + 'verificar_empresa', {
            tokencontrato: tokencontrato,
        })
    },

    verificaLink: (link) => {
        return http.post(route + 'verificar_link', {
            link: link,
        })
    },

    verificaAcessoUsuario: (chaveativacao) => {
        return http.post(route + 'verifica_acesso', { chaveativacao: chaveativacao })
    },

    atualizar: (usuarioprodutor) => {
        return http.post(route + 'editar_perfil', usuarioprodutor)
    },

    desativar: (chaveativacao) => {
        return http.post(route + 'desativar_perfil', { chaveativacao: chaveativacao })
    },
}
